import * as R from 'ramda';
// utilities
import { isString, isNumber } from './common';
////////////////////////////////////////////////

const toNumber = num => Number(num);

const toFixed = (value, qty) => {
  if (isNumber(value)) return value.toFixed(R.or(qty, 0));

  if (isString(value)) return toNumber(value).toFixed(R.or(qty, 0));

  return value;
};

const fromKmsToMiles = (val, toFixedNumber) => (
  val ? toNumber((val / 1.6093).toFixed(R.or(toFixedNumber, 2))) : null
);

const fromMilesToKms = (val, toFixedNumber) => (
  val ? toNumber((val * 1.6093).toFixed(R.or(toFixedNumber, 2))) : null
);

const calculatePercentage = (totalValues, processedValues) => {
  if (R.or(R.lte(totalValues, 0), R.lt(processedValues, 0))) return 0;

  return R.compose(
    R.min(100),
    R.multiply(100),
    R.divide(R.__, totalValues),
  )(processedValues);
};

export {
  toFixed,
  fromKmsToMiles,
  fromMilesToKms,
  calculatePercentage,
};
